export default __webpack_public_path__ + "assets/4ba44fe7f6a5a390ea9fb914040bfd0f.svg";